import common from "../common";
import Scene from "./Scene";
import GelButton from "../ui/GelButton";

export default class BoardFlipScene extends Scene 
{
    constructor(boardType, id)
    {
        super('boardflip');

        this.type = boardType;
        this.id = id;
    }

    init()
    {
        super.init();

        if(this.type == 'image')
        {
            common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/' + this.id + '.png', (pixelData) => {
                console.log(pixelData);
                MEDIATOR.pcApp.setBoardImage(pixelData);
            });
        }
        else if(this.type == 'text')
        {
            common.boardGraphicGenerator.getPixelsFromText(this.id, (pixelData) => {
                console.log(pixelData);
                MEDIATOR.pcApp.setBoardImage(pixelData);
            });
        }
        else if(this.type == 'years')
        {
            common.boardGraphicGenerator.getPixelsFromText(this.id, (pixelData) => {
                console.log(pixelData);
                MEDIATOR.pcApp.setBoardImage(pixelData);
            });
        }
        else if(this.type == 'player')
        {
            common.boardGraphicGenerator.getPixelsFromPlayer(this.id, (pixelData) => {
                console.log(pixelData);
                MEDIATOR.pcApp.setBoardImage(pixelData);
            });
        }

        common.soundManager.play('music_sting_woah_00');

        common.soundManager.play(['sfx_crowd_roar_layer_01', 'sfx_crowd_roar_layer_02', 'sfx_crowd_roar_layer_03']);
    }

    postInit()
    {
        super.postInit();
    }

    boardsFlipped()
    {
        setTimeout(() => {
            this.signals.next.dispatch();
        }, 1000);
    }
}